export default __webpack_public_path__ + "static/media/clock.f03bac9a.png";